import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation, Switch, Route, Redirect } from 'react-router-dom';
import ConnectedAccount from '../Settings/Account/ConnectedAccount';
import Settings from './Settings';

function ConnectedSettings() {
    return (
        <>
            <Switch>
                <Route path="/portal/settings/accountInformation">
                    <ConnectedAccount />
                </Route>
                <Route path="/portal/settings/updateEmail">
                    <ConnectedAccount />
                </Route>
                <Route path="/portal/settings/changePassword">
                    <ConnectedAccount />
                </Route>
                <Route path="/portal/settings">
                    <Settings />
                </Route>

                <Redirect to="/portal/settings" />
            </Switch>
        </>
    );
}

export default ConnectedSettings;
